<template>
  <div>
    <PageTitle
      title="Event Type List"
      :btnCreate="true"
      :createRoute="'/purchase/add'"
      :createPopup="true"
      :permission="'Category Create'"
      @onClickCreate="OpenModal()"
    />
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content mb-2" v-show="show">
          <v-row class="ma-0 align-right">
            <TableFilters
              :filters="['search', '']"
              v-model="filter"
              :columns="columns"
              :msgs="'Name'"
            ></TableFilters>
          </v-row>
        </v-card>
      </v-expand-transition>
      <v-card class="lighten-12 card-content mt-0 pa-3">
        <v-col
          class="pr-1 text-right"
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          xl="2"
        >
          <EventTypeForm
            ref="createcategory"
            :EventType="EventType"
            :visible="isEventTypeFormVisible"
            @close="AddCategory($event)"
            @afterSave="refreshData()"
          />
        </v-col>
        <v-progress-linear
          active="false"
          indeterminate="false"
          :query="false"
          v-if="isLoading"
        ></v-progress-linear>
        <v-data-table
          :fixed-header="true"
          :headers="headers"
          :items-per-page="paginationOptions.perPage"
          :items="ProductCategory"
          class="row-pointer event-txt"
          item-key="id"
          hide-default-footer
        >
          <template v-slot:no-data>
            <noData
              class="mt-10 container justify-center item-center"
              name="event type list"
            />
          </template>
          <!-- No -->
          <template v-slot:item.no>
            <v-icon>mdi-vuetify</v-icon>
          </template>
          <template v-slot:item.name="{ item }" :slot-scope="props">
            {{ item.name }}
          </template>
          <template v-slot:item.color="{ item }" :slot-scope="props">
            <v-btn
              :color="item.color"
              dark
              style="width: 15px; height: 20px"
              v-on="on"
            >
            </v-btn>
          </template>

          <!-- Status -->
          <template v-slot:item.status="{ item }">
            <v-chip
              :x-small="true"
              class="ma-2 cursor-pointer"
              label
              text-color="white"
              :color="getStatusColor(item.is_active)"
              dark
              >{{ item.is_active ? 'Active' : 'Archived' }}</v-chip
            >
          </template>

          <!-- Action -->
          <template v-slot:item.action="{ item }">
            <list-menu
              feature="event-type"
              :item="item"
              @refreshList="refreshData"
              editPermission="Event Type Edit"
              @onEditClicked="EditModal(item)"
              :isEditModal="true"
              :isSubViewModal="true"
              softDeletePermission="Event Type Soft Delete"
              @onSubViewClicked="ViewCategory(item)"
            ></list-menu>
          </template>

          <template v-slot:footer>
            <pagination
              url="event-type"
              @paginationOptions="setPaginationOptions"
              @response="receiveCategoryData"
              :filterAction="true"
              @getPageNumber="setPagenumber"
              :filter="filter"
              ref="pagination"
            />
          </template>
        </v-data-table>

        <EditEventTypeForm
          :visible="EditScheduleForm"
          ref="editEvent"
          :EventType="EventType"
          @afterSave="refreshData()"
          @close="EditEventTypeForm($event)"
        />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import TableFilters from '@/components/base/TableFilters';
import EventTypeForm from './EventCreate.vue';
import { required, email, max } from 'vee-validate/dist/rules';
import pagination from '../shared/components/pagination';
import axios from '@/plugins/axios';

import EditEventTypeForm from './EditEventType.vue';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { EventType } from '@/models/EventType.js';
import noData from '../../components/shared/noItem';

extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});

export default {
  data: () => ({
    show: false,
    on: {
      click: console.log,
      contextmenu: console.log,
    },
    inheritAttrs: false,
    isLoading: false,
    paginationOptions: {},
    isEventTypeFormVisible: false,
    EditScheduleForm: false,
    EventType: new EventType(),
    pagination1: {
      descending: true,
      page: 1,
      total: 0,
      rowsPerPage: 2,
      sortBy: 'fat',
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pagination: {
      page: 1,
      itemsPerPage: 2,
    },
    page: 1,
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    columns: [
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: false,
        width: '12.5%',
        align: 'center',
      },
      {
        text: 'Code',
        value: 'code',
        show: true,
        disabled: false,
        width: '12.5%',
        align: 'center',
      },
      {
        text: 'Color',
        value: 'color',
        show: true,
        disabled: false,
        width: '12.5%',
        align: 'center',
      },

      {
        text: 'Readonly',
        value: 'readonly',
        show: true,
        disabled: false,
        width: '12.5%',
        align: 'center',
      },
      {
        text: 'Is holiday',
        value: 'is_holiday',
        show: true,
        disabled: false,
        width: '12.5%',
        align: 'center',
      },
      {
        text: 'Description',
        value: 'description',
        show: true,
        disabled: false,
        width: '12.5%',
        align: 'center',
      },
      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        align: 'center',
        width: '12.5%',
      },

      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
        width: '12.5%',
      },
    ],
    ProductCategory: [],

    filter: {
      name: '',
      search: '',
      status: '',
    },
  }),
  computed: {
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,

    pagination,
    EventTypeForm,
    EditEventTypeForm,
    noData,
    TableFilters,
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },

    clearFilter() {
      this.filter = {};
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },

    OpenModal() {
      this.isEventTypeFormVisible = true;
      this.EventType = new EventType();
    },

    receiveCategoryData(data) {
      this.ProductCategory = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    AddCategory($event) {
      this.isEventTypeFormVisible = false;
    },
    EditModal(data) {
      this.EditScheduleForm = true;

      this.GrtEventTypeBySingle(data.id);
    },
    EditEventTypeForm($event) {
      this.EditScheduleForm = false;
    },

    GrtEventTypeBySingle(id) {
      axios
        .get(`event-type/${id}`)
        .then((res) => {
          this.EventType = res.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.event-txt {
  /* font-weight: bold; */
  font-family: 'Source Sans Pro', sans-serif;
}
.min-button::before {
  display: none;
}
</style>
